/* eslint-disable complexity */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  getFilteredPredictiveSearchList,
  getPredictiveSearchList
} from '../../adapters/predictive-search/predictive-search.adaptor';
import { BookWidgetStoreKey } from '../../constants/common.constants';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';

const bookWidgetStoreFeatureSelector =
  createFeatureSelector<BookWidgetStore>(BookWidgetStoreKey);

const getPredictiveSearchState = createSelector(
  bookWidgetStoreFeatureSelector,
  (state) => state.predictiveSearch
);

export const getPredictiveSearchListWithFilter = createSelector(
  getPredictiveSearchState,
  ({ predictiveSearchResponse, searchText }) => {
    if (!predictiveSearchResponse || !searchText) return null;

    if (searchText.length === 3) {
      return getPredictiveSearchList(predictiveSearchResponse).airportList;
    }

    const filteredResponse = getFilteredPredictiveSearchList(
      predictiveSearchResponse,
      searchText
    );
    return filteredResponse.length
      ? getPredictiveSearchList(filteredResponse).airportList
      : getPredictiveSearchList(predictiveSearchResponse).airportList;
  }
);

export const predictiveSearchApiFailed = createSelector(
  getPredictiveSearchState,
  ({ isError }) => isError
);
